import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/dealer-managers');
}
//Get all active 
export function allActive(){
    return http().get('/dealer-managers/active');
}
// Get all active dealer managers for dropdown
export function dropdown(){
    return http().get('/dealer-managers/dropdown');
}
//Get Single
export function single(id){
    return http().get(`/dealer-managers/${id}`);
}
//Add one
export function add(data){
    return http().post('/dealer-managers', data)
}
//Update
export function update(id, data){
    return http().put(`/dealer-managers/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/dealer-managers/${id}`);
}